<template>
    <article>
        <p class="text-grey-70 pb-2">Candidates who use Agency Central to find a job agency will have
            access to the most relevant information all in one place. An advanced search and filter
            system will quickly allow you to target the agencies who can help, whether they are
            specialists, or just around the corner from you.</p>
        <p class="text-grey-70 pb-2">To help you understand your career progression, we also list
            salaries by job role and location.</p>
        <p class="text-grey-70 pb-2">Recruitment agencies can guide your career in the right direction
            and have access to the best employers in your region, giving you the greatest chance of
            being placed in the perfect job for you.</p>
        <p class="text-grey-70">Use the search above to get started.</p>
    </article>
</template>

<script>
export default {
    name: "CandidateInfo"
}
</script>
